export default __webpack_public_path__ + "static/media/AcornMallFastFood_41.33a8e816.png";